/**
 * Plugin operates the main password confirm modal added to the APP root element.
 *
 * Usage:
 *   - from component
 *      this.$passwordConfirmPluginModal.show(params);
 *   - from actions or other resources that do not have an access to the vue object
 *      - pass in the 'this.$passwordModal' as parameter
 *      - then call 'show' on that parameter
 *
 * @param title Optional. Title for the modal. If omitted then the type is used as title.
 * @param message Message for the modal content box.
 * @param type Optional. Type of the modal. Possible options are 'ERROR', 'INFO'. Default 'INFO'.
 * @param confirmButtonText Optional. Text for the callback button. Default 'Confirm'.
 * @param confirmCallback Optional. Method to be executed from the modal.
 */

import PasswordConfirmModalComponent from './PasswordConfirm.modal';

const PasswordConfirmPluginModal = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.component('password-confirm-modal-sb', PasswordConfirmModalComponent);
    Vue.prototype.$passwordConfirmPluginModal = {
      show(params) {
        Vue.prototype.$infoModalEventBus.$emit('showPasswordConfirmModal', params);
      },
    };
  },
};

export default PasswordConfirmPluginModal;
